import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'phdsoft-formly-field-file',
    templateUrl: './formly-fieldfile.component.html'
})
export class FormlyFieldFileComponent extends FieldType {

}
